import styles from "./PlainWrapper.module.scss";

import { ListWrapperProps } from "../ModalCrudRoute";
import { PropsWithChildren } from "react";

export const PlainWrapper = ({ children }: PropsWithChildren<ListWrapperProps>) => {
    return <div className={styles.container}>{children}</div>;
};
